import { connectStats } from "instantsearch.js/es/connectors";
import { provide, ref } from "vue";
export const useAisStats = (widgetParams, id = "") => {
  const stateRef = ref();
  const renderStats = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (isFirstRender) {
      provide(`stats-${id}`, stateRef);
    }
    return () => {
    };
  };
  const customStats = connectStats(renderStats);
  return { ...customStats(widgetParams), $$widgetParams: widgetParams, $$widgetId: id };
};
